














































import { Component, Prop, Mixins } from 'vue-property-decorator';
import BaseLoaderCircular from '../base-loader-circular/_base-loader-circular.vue';
import BaseIcon from '../base-icon/_base-icon.vue';
import { ModalRoot } from './mixins/modal-root';
import { EModalSize } from './types/enums/modal-size';

@Component({
  name: 'BaseModal',
  components: {
    BaseIcon,
    BaseLoaderCircular,
  },
})
export default class BaseModal extends Mixins(ModalRoot) {
  @Prop() displayMobile: boolean;
  @Prop({ default: EModalSize.Small }) size: EModalSize;
  @Prop({ default: true }) closable: boolean;
  @Prop({ default: false }) darkMode?: boolean;

  usePadding(): boolean {
    return !this.hasSubContainer() && this.padded;
  }

  hasSubContainer(): boolean {
    return !!this.$slots.container;
  }

  handleClose() {
    if (this.closable) {
      this.$emit('close');
    }
  }

  handleEscape(e: KeyboardEvent) {
    if (e.key !== 'Escape') {
      return;
    }
    this.handleClose();
  }

  mounted() {
    if (this.closable) {
      window.addEventListener('keyup', this.handleEscape);
    }
  }
}
